import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ff5c67',
      light: '#ff8d78',
      dark: '#ef4444',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ff8d78',
      light: '#ffd4cc',
      dark: '#ff6b6b',
      contrastText: '#ffffff',
    },
    background: {
      default: '#fff7f6',
      paper: '#ffffff',
    },
    text: {
      primary: '#1f2937',
      secondary: '#6b7280',
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        *, *::before, *::after {
          font-family: 'Poppins', sans-serif !important;
        }
        body {
          font-family: 'Poppins', sans-serif !important;
          background: #fff7f6 !important;
        }
      `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          textTransform: 'none',
          fontWeight: 700,
        },
        containedPrimary: {
          background: 'linear-gradient(180deg, #ff8d78 0%, #ff5c67 100%)',
          boxShadow: '0 12px 24px rgba(255, 92, 103, 0.22)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 20,
        },
      },
    },
  },
});

export default theme;
